(ns manatee.components.header.container
  (:require [kee-frame.core :as kf]
            [manatee.annotation.autosaving :as autosaving]
            [manatee.annotation.subs :as annotation-subs]
            [manatee.auth.handlers :as auth-handlers]
            [manatee.components.notifications.container :as note-container]
            [manatee.components.notifications.handlers :as note-handlers]
            [manatee.components.notifications.subs :as note-subs]
            [manatee.info.handlers :as info-handlers]
            [manatee.ui.handlers :as ui-handlers]
            [manatee.ui.subs :as ui-subs]
            [manatee.user.subs :as user-subs]
            [re-frame.core :as rf]
            [rothko.button.component :refer [button]]
            [rothko.header.component :as header]
            [rothko.nav.component :as nav]))

(defn container
  []
  (let [admin? @(rf/subscribe [::user-subs/admin?])
        project-owner? @(rf/subscribe [::user-subs/project-owner?])
        senior-annotator? @(rf/subscribe [::user-subs/senior-annotator?])
        evaluator? @(rf/subscribe [::user-subs/evaluator?])
        logged-in? @(rf/subscribe [::user-subs/logged-in?])
        announcements @(rf/subscribe [::note-subs/announcements])
        show-announcements? @(rf/subscribe [::note-subs/show-announcements?])
        {:keys [first-name last-name]} @(rf/subscribe [::user-subs/user])
        margins {:style {:margin-top "1.3rem" :margin-bottom "1.3rem"}}]
    [header/main
     {:appearance (if evaluator? #{:evaluator} #{:primary})
      :style {:display :table}
      :left-container [margins
                       [:div [:h3 {:style {:display :inline}} "Manatee"] [:span " - Annotation Tool"]]
                       (when (seq announcements)
                         [:div
                          [:h3 {:style {:display :inline :margin-left "4em"}} " "] ; space things out
                          [button {:class [:link]
                                   :style {:background-color "transparent" :display :inline}
                                   :on-click #(rf/dispatch [::note-handlers/show-announcements (not show-announcements?)])}
                           (str "Announcements\u00A0"
                                (if show-announcements? "▲" "▼"))]])]
      :right-container [margins
                        [:span.header__username (str (when evaluator? "EVALUATOR MODE - ") first-name " " last-name)]
                        [header/sign-in-out-button
                         {:logged-in? logged-in?
                          :login-path (kf/path-for [::auth-handlers/login])
                          :sign-in-text "Sign in"
                          :sign-in-visible? true
                          :sign-out-handler #(rf/dispatch [::auth-handlers/sign-out])
                          :sign-out-text "Sign out"}]
                        [:a {:style {:text-decoration :none}
                             :href (kf/path-for [:api/user-guide])
                             :target "_blank"
                             :download "MANATEE_USER_GUIDE.pdf"
                             :type "application/pdf"}
                         [:span.header__support "Help"]]
                        [header/hamburger-menu-button
                         {:burger-bun-width 20
                          :cross-width 20
                          :menu-open? @(rf/subscribe [::ui-subs/menu-open?])
                          :menu-toggle-handler #(do (rf/dispatch [::autosaving/check-if-should-offer-clearing-autosaved-items])
                                                    (rf/dispatch [::ui-handlers/toggle-menu]))}]]
      :menu-open? @(rf/subscribe [::ui-subs/menu-open?])
      :side-nav [[nav/nav {:current-route @(rf/subscribe [:kee-frame/route])
                           :menu-toggle-handler #(rf/dispatch [::ui-handlers/toggle-menu])
                           :appearance #{:vertical}
                           :theme :manatee
                           :items (if logged-in?
                                    [{:icon  :book
                                      :key   :annotate
                                      :route [:manatee.annotation.handlers/annotate]
                                      :title "Annotate"}
                                     {:icon  :graph
                                      :key   :dashboard
                                      :route [:manatee.dashboard.handlers/dashboard]
                                      :title "Dashboard"}
                                     (when @(rf/subscribe [::annotation-subs/offer-clearing-autosaved-items])
                                       {:icon        :bin
                                        :key         :clear-autosaved-items
                                        :selected-fn (constantly false)
                                        :on-click    #(rf/dispatch [::autosaving/clear-all-autosaved-items])
                                        :title       "Clear Autosaved Items"})
                                     (when (or admin? project-owner?)
                                       {:icon  :user
                                        :key   :admin
                                        :route [:manatee.admin.handlers/admin]
                                        :title "Admin"})
                                     (when admin?
                                       {:icon  :eye
                                        :key   :dev
                                        :route [:manatee.sysadmin.handlers/main]
                                        :title "Sysadmin"})
                                     (when (or admin? project-owner? senior-annotator?)
                                       {:icon  :tick
                                        :key   :qa
                                        :route [:manatee.edit.handlers/edits]
                                        :title "QA"})
                                     {:icon     :info
                                      :key      :about
                                      :on-click #(rf/dispatch [::info-handlers/load-info-view])
                                      :title    "About"}]

                                      ; User is not logged in; allow them to
                                      ; view the Info. pop-up.
                                    [{:icon     :info
                                      :key      :about
                                      :on-click #(rf/dispatch [::info-handlers/load-info-view])
                                      :title    "About"}])
                           :route-handler kf/path-for}]]}
     (when (and announcements show-announcements?) [note-container/announcements announcements])]))
